import { Alert, Snackbar } from '@mui/material';

/**
 * Snackbar padronizado — elimina o boilerplate de 7 linhas repetido em ~19 arquivos.
 *
 * Integra com o `useSnackbar` hook — basta passar o `snackbar` state e `onClose`.
 *
 * @param {Object}   snackbar           - Estado retornado por useSnackbar()
 * @param {boolean}  snackbar.open      - Visibilidade do snackbar
 * @param {string}   snackbar.message   - Mensagem exibida
 * @param {string}   snackbar.severity  - 'success' | 'error' | 'warning' | 'info'
 * @param {Function} onClose            - Callback para fechar (use hideSnackbar do hook)
 * @param {number}   [autoHideDuration] - Tempo em ms para fechar automaticamente (default: 4000)
 *
 * @example
 * const { snackbar, showSuccess, showError, hideSnackbar } = useSnackbar();
 *
 * // No retorno do componente:
 * <AppSnackbar snackbar={snackbar} onClose={hideSnackbar} />
 */
export default function AppSnackbar({ snackbar, onClose, autoHideDuration = 4000 }) {
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert onClose={onClose} severity={snackbar.severity} sx={{ width: '100%' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
